// Search By Name Filter

export default function SearchByNameFilter() {
	return function(products, query) {
		var toReturn = [];
  
		for (var i = 0; i < products.length; i++) {
		  if (products[i].name.search(new RegExp(query, "i")) > -1) {
			toReturn.push(products[i]);
		  }
		}
  
		return toReturn;
	  };
}